import React from "react";

import OrganizerTools from "./OrganizerTools";

const QA: React.FC = () => {
  return (
    <span>
      <OrganizerTools
        bugnub={{
          teamId: "ac6ec63d-bf79-4fa2-95c3-364a1f0b0d38",
          token: "9RQYZyziWGRIfGFZEkLNhlpskAt9T24D",
        }}
      />
    </span>
  );
};

export default QA;
